import type {ReactElement} from 'react';
import React from 'react';
import {isEditorMobileVariant} from '@Components/poster-editor/library/poster-editor-library';
import {EDITOR_RIGHT_MARGIN, EDITOR_RIGHT_MARGIN_SMALL} from '@Components/poster-editor/library/poster-editor-scrolling-library';
import {useAppSelector} from '@/hooks';
import {PosterModeType} from '@PosterWhiteboard/poster/poster-mode.class';

export function FloatyEditorRightMargin(): ReactElement<any> | null {
  const isSidebarSmall = useAppSelector((state) => {
    return state.posterEditor.isSidebarSmall;
  });
  const isInGeneration = useAppSelector((state) => {
    return state.posterEditor.posterObject?.mode.details.type === PosterModeType.GENERATE;
  });
  const isWebPage = useAppSelector((state) => {
    return state.posterEditor.posterObject?.mode.details.type === PosterModeType.WEB_PAGE;
  });

  if (isEditorMobileVariant() || isInGeneration || isWebPage) {
    return null;
  }

  return (
    <div
      style={{
        width: `${isSidebarSmall ? EDITOR_RIGHT_MARGIN_SMALL : EDITOR_RIGHT_MARGIN}px`,
        minWidth: `${isSidebarSmall ? EDITOR_RIGHT_MARGIN_SMALL : EDITOR_RIGHT_MARGIN}px`,
        height: '100%',
      }}
    />
  );
}
